import { render, staticRenderFns } from "./APIDataCountTableView.vue?vue&type=template&id=5a4ae8e7&scoped=true"
import script from "./APIDataCountTableView.vue?vue&type=script&lang=js"
export * from "./APIDataCountTableView.vue?vue&type=script&lang=js"
import style0 from "./APIDataCountTableView.vue?vue&type=style&index=0&id=5a4ae8e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ae8e7",
  null
  
)

export default component.exports